import { render, staticRenderFns } from "./ViewDetailBooking.vue?vue&type=template&id=1a470712&"
import script from "./ViewDetailBooking.vue?vue&type=script&lang=js&"
export * from "./ViewDetailBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a470712')) {
      api.createRecord('1a470712', component.options)
    } else {
      api.reload('1a470712', component.options)
    }
    module.hot.accept("./ViewDetailBooking.vue?vue&type=template&id=1a470712&", function () {
      api.rerender('1a470712', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/local/vsl/VesselScheduleSearch/ViewDetailBooking.vue"
export default component.exports